import React, { useEffect, useContext, useState, useMemo } from "react";
import ReactDOM from "react-dom";
import { Typography, Paper, IconButton, Button } from "@material-ui/core";
import clsx from "clsx";
import useStyles from "../../styles/accessManagementStyle";
import { url } from "../../apis/apiSetup";
import { SubmitBtnContext } from "../../App";
import "../../css/dataTable.css";
import { useTranslation } from "../../langs/useTranslation";
import * as localforage from "localforage";
import * as $ from "jquery";
import "datatables.net";
import "datetime-moment";
import { ReplayOutlined, SendOutlined } from "@material-ui/icons";
import StyledSubmitBtn from "../commons/StyledSubmitBtn";
import { useParams } from "react-router-dom";
import EditRolePermissionSwitch from "./EditRolePermissionSwitch";
import { updateRoleWithPermissionsAPI } from "../../apis/updateRoleWithPermissionsAPI";
import { successHandling } from "../../helpers/successHandling";
import { searchStyleRender } from "../../helpers/datatableSearchIconRender";
import { errorHandling } from "../../helpers/errorHandling";
import { ReactRender } from "../ReactRender";

const RolePermissionTable = ({ systemRoles }) => {
  const classes = useStyles();
  const { role_id, role_name } = useParams();
  const { t } = useTranslation("accessManagement");
  const { dispatch } = useContext(SubmitBtnContext);
  const [permissions, setPermissions] = useState([]);
  const [type, setType] = useState(1);

  const disableEdit = useMemo(() => {
    return systemRoles.includes(role_name);
  }, []);

  const handleUpdateRolePermission = async () => {
    try {
      dispatch({ type: "showLoading" });
      await updateRoleWithPermissionsAPI(role_id, role_name, type);
      successHandling(t, "setting.successfullyUpdatePermission", "success");
      table(type);
    } finally {
      dispatch({ type: "stopLoading" });
    }
  };

  const table = async type => {
    const token = await localforage.getItem("token");
    $("#role-permission-table").DataTable({
      processing: true,
      language: {
        zeroRecords: `${t("table.zeroRecords")}`,
        loadingRecords: `${t("table.loadingRecords")}`,
        infoEmpty: `${t("table.noRecordsAvailable")}`,
        processing:
          '<div class="loading-wrapper table-loading-wrapper"><div class="loadingio-spinner-ellipsis-0e9htm6lpb7"><div class="ldio-tk8dyrglbc"><div></div><div></div><div></div><div></div><div></div></div></div></div>'
      },
      searching: true,
      filter: false,
      deferRender: true,
      info: false,
      autoWidth: false,
      stateSave: false,
      destroy: true,
      pageLength: 15,
      ordering: false,
      order: [[0, "asc"]],
      ajax: {
        url:
          type === 1
            ? `${url}/api/v1/roles/edit`
            : `${url}/api/v1/roles/nubis/edit`,
        type: "GET",
        dataSrc: function (json) {
          const { permissions = [], rolePermissions = {} } = json;
          const finalPermissions = permissions
            // .filter(item => item.permissionAssignedToRole === "checked")
            .filter(item => item.name !== "Update Center")
            .map(item => {
              return {
                ...item,
                permissionAssignedToRole: rolePermissions[item.id]
                  ? "checked"
                  : ""
              };
            });
          setPermissions(permissions);
          const rolePermissionNames = Object.values(rolePermissions).map(
            v => v.name
          );
          const permissionNames = permissions.map(v => v.name);
          const extraPermissions = rolePermissionNames.filter(
            v => !(permissionNames.indexOf(v) >= 0)
          );
          localforage.setItem(`extra_${role_id}`, extraPermissions);
          return finalPermissions;
        },
        data: {
          role_id: role_id
        },
        beforeSend: request => {
          request.setRequestHeader("Authorization", "Bearer " + token);
          request.setRequestHeader("Accept", "application/json");
        },
        error: (xhr, status, error) => {
          errorHandling(error);
        }
      },
      columns: [
        {
          data: "name",
          title: `${t("table.permissionTitle")}`,
          searchable: true,
          createdCell: (td, data) => {
            ReactRender(
              <Typography variant="body1">
                {type === 1
                  ? t(`platform_permissions.${data}`)
                  : t(`nubis_permissions.${data}`).replace("nubis_permissions", "permissions")}
              </Typography>,
              td
            );
          }
        },
        {
          data: "permissionAssignedToRole",
          title: `${t("table.statusTitle")}`,
          searchable: true,
          className: "switch-column",
          createdCell: async (td, data, rowData) => {
            ReactRender(
              <EditRolePermissionSwitch
                permissionId={rowData.id}
                initialChecked={data === "checked" ? true : false}
                roleId={role_id}
                permissionData={rowData}
                disabled={disableEdit}
              />,
              td
            );
          }
        }
      ]
    });
    // render Material UI Search Input
    searchStyleRender();
  };

  const handleReloadDataTable = () => {
    table(type);
  };

  const storedPermissionsToLocalforage = async () => {
    await localforage.setItem(role_id, permissions);
  };

  useEffect(() => {
    storedPermissionsToLocalforage();
  }, [permissions]);

  useEffect(() => {
    table(type);
  }, [type]);

  return (
    <Paper
      elevation={0}
      className="fullwidth-table-wrapper reset-margin-top-table"
    >
      <Typography variant="h6">{role_name}</Typography>
      <div className={clsx(classes.tableHeader, classes.tableAction)}>
        <IconButton
          aria-label="reload table"
          className={classes.margin}
          size="small"
          onClick={handleReloadDataTable}
        >
          <ReplayOutlined />
        </IconButton>
        {!disableEdit && (
          <div className={classes.styledSubmitBtnWrap}>
            <StyledSubmitBtn
              btnColor="primary"
              variant="contained"
              btnText={t("table.confirmBtn")}
              startIcon={<SendOutlined />}
              onClick={handleUpdateRolePermission}
            />
          </div>
        )}
      </div>
      <div className={classes.tabs}>
        <Button
          className={clsx(type === 1 && classes.alphaButton)}
          onClick={() => setType(1)}
        >
          Platform
        </Button>
        <Button
          className={clsx(type === 2 && classes.alphaButton)}
          onClick={() => setType(2)}
        >
          Device Center
        </Button>
      </div>
      <table id="role-permission-table" className="mdl-data-table"></table>
    </Paper>
  );
};

export default RolePermissionTable;
